<template>
    <button
        type="button"
        @click="clicked"
        class="inline-flex items-center px-6 py-2 mx-2 text-base font-medium leading-6 text-white transition duration-150 ease-in-out border border-transparent rounded-md focus:outline-none"
        :class="{
            'bg-green-500 hover:bg-green-600  focus:border-green-300 focus:shadow-outline-green-600 active:bg-green-600':
                color === 'green',
            'bg-red-500 hover:bg-red-600  focus:border-red-300 focus:shadow-outline-red-600 active:bg-red-600':
                color === 'red'
        }"
    >
        {{ title }}
    </button>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        color: {
            default: "green"
        }
    },
    methods: {
        clicked() {
            this.$emit("click");
        }
    }
};
</script>

<style></style>
